import CardList from "app/components/card-list/card-list";
import CardListItem from "app/components/card-list/card-list-item";
import CardListTagMenu from "app/components/card-list/card-list-tag-menu";
import whoWeServeData from "app/components/who-we-serve/data";
import { TagProvider } from "app/context/tags";
import { useTaggedData } from "app/hooks/useTaggedData";
import { Trans } from "react-i18next";

const batchCount = 8;

export const MerchantImages = () => {
  const {
    currentTag,
    displayCount,
    setDisplayCount,
    tags,
    currentData,
    currentPaginatedData,
  } = useTaggedData(whoWeServeData, batchCount, true);

  return (
    <div className="flex w-full flex-col items-center">
      <div className="w-full overflow-x-auto px-6 py-2">
        <CardListTagMenu tags={tags} currentTag={currentTag} />
      </div>
      <CardList data={currentPaginatedData} CardListItem={CardListItem} />
      <button
        className={`
          ${
            currentData.length <= displayCount
              ? "hidden"
              : "mx-auto block rounded-full border-2 border-black px-6 py-2"
          }
        `}
        onClick={() => setDisplayCount(displayCount + batchCount)}
      >
        <p className="font-bold">
          <Trans>Load More</Trans>
        </p>
      </button>
    </div>
  );
};

export const MerchantList = () => (
  <TagProvider>
    <MerchantImages />
  </TagProvider>
);
